export const enableDevBypass = () => {
  if (!window) return;

  window.localStorage.setItem('dev_task_bypass', 'true');

  window.location.reload();
};

export const disableDevBypass = () => {
  if (!window) return;

  window.localStorage.setItem('dev_task_bypass', 'false');

  window.location.reload();
};

export const getDevBypass = () => {
  if (!window) return;

  const devBypass = window.localStorage.getItem('dev_task_bypass');

  if (devBypass) {
    return JSON.parse(devBypass);
  }

  return false;
};